export enum MFComponentEnum {
  SURVEY_FORM = 'surveyForm',
}
